import React from "react";
import styled from "styled-components";

export const Button = styled((props) => <button {...props} />).attrs((props) => ({
  automationid:
    props.automationid ||
    `SalesLead_button_${props?.automationidattr?.replace(/ /g, "")}_1"`,
}))`
  box-sizing: border-box;
  border-radius: 6px;
  color: #282828;
  background: transparent;
  outline: none;
  padding: 0.6rem 2rem;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 700;
  font-size: 1rem;
  font-family: "Roboto";

  @media (max-width: 450px) {
    width: 100%;
  }
`;
